import Page from 'components/layout/Page';
import TalentEngineFooter from '../sections/footer/TalentEngineFooter';
import {
  StyledFeatureList,
  StyledHeader,
  StyledPage,
  StyledWrapper
} from './TalentEnginePage.styled';
import TENav from '../sections/nav/Nav';
import { useI18n } from 'hooks/useI18n';
import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading1 } from 'components/shared/Typography';
import { SAVEPAGEFEATURES } from './TalentEnginePage.constants';
import TEFeature from './feature/Feature';
import { Link } from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { ButtonLink } from 'components/shared/ButtonLink';
import ServiceEventTracking from 'services/service.event-tracking';

const TalentEngineSave: React.FC = () => {
  const { t } = useI18n('talent-engine-save');

  const features = SAVEPAGEFEATURES(t);

  return (
    <Page pageVariant="light">
      <TENav />
      <StyledPage>
        <StyledWrapper>
          <StyledHeader>
            <Heading1>{t('talent-engine-save.hero.title')}</Heading1>
            <HtmlTrans
              ns="talent-engine-save"
              i18nKey={t('talent-engine-save.hero.desc')}
            />
            <Link to="talentEngineForm" href="#talentEngineForm">
              <ButtonLink
                as="div"
                onClick={() =>
                  ServiceEventTracking.trackLandingCtaClicked(
                    'talent-engine-quiero-sublanding-ahorra-tiempo'
                  )
                }
              >
                <FontAwesomeIcon icon={faCheckCircle} />
                <span>{t('talent-engine-save.hero.cta')}</span>
              </ButtonLink>
            </Link>
          </StyledHeader>
          <StyledFeatureList>
            {features.map((feature, index) => (
              <TEFeature
                key={index}
                title={feature.title}
                image={feature.image}
                desc={feature.desc}
              />
            ))}
          </StyledFeatureList>
        </StyledWrapper>
        <TalentEngineFooter isLight />
      </StyledPage>
    </Page>
  );
};

export default TalentEngineSave;
